import { handleError, handleSuccess, triggerDelete, triggerGet, triggerPost, triggerPut } from './utils';

const getAllSubservicesApiRequest = async (id, isPublic = false) => {
  const apiResponse = await triggerGet(`/${isPublic ? 'public' : 'business'}/services/${id}/subservices/`, !isPublic);
  const responseData = await apiResponse.json();

  if (responseData.report.status === 200) {
    const { data } = handleSuccess(responseData);
    const newData = data.filter(x => !isPublic || x.subservicesActive === 'Y');
    return {
      success: true,
      data: newData,
    };
  }
  return handleError(responseData);
};

const toggleSubserviceActiveStatusApiRequest = async (id, ssid) => {
  const apiResponse = await triggerGet(`/business/subservices/status/${ssid}`);
  const responseData = await apiResponse.json();

  if ([200, 201].includes(responseData.report.status)) {
    return {
      success: true,
      data: [],
      report: {},
    };
  }

  return handleError(responseData);
};

// Delete a Subservice
const deleteSubserviceApiRequest = async (id, ssid) => {
  const apiResponse = await triggerDelete(`/business/services/${id}/subservices/${ssid}`);

  if (apiResponse.status === 204) {
    return {
      success: true,
      data: [],
      report: {},
    };
  }

  return {
    success: false,
  };
};

const assignResourcesToSubserviceApiRequest = async (id, ids) => {
  const apiResponse = await triggerPost(`/business/subservices/${id}/resources`, {
    subservicesResourcesIds: ids,
  });
  const responseData = await apiResponse.json();

  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }

  return handleError(responseData);
};

const changeSubservicesOrderApiRequest = async newArr => {
  const id = newArr[0].subservicesServicesId;
  const ids = {
    subservicesOrder: newArr.map(x => x.subservicesId).join(','),
  };
  const apiResponse = await triggerPut(`/business/services/${id}/subservices/`, ids);

  if (apiResponse.status === 200) {
    return {
      success: true,
      data: newArr,
      report: {},
    };
  }

  return {
    success: false,
  };
};

export {
  assignResourcesToSubserviceApiRequest,
  changeSubservicesOrderApiRequest,
  deleteSubserviceApiRequest,
  getAllSubservicesApiRequest,
  toggleSubserviceActiveStatusApiRequest,
};
